import React, { Component } from 'react';
import { withLocalize } from 'react-localize-redux';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { lastSubjectActions } from '../../store/lastSubjectsStore';
import { newsActions } from '../../store/newsStore';
import { userContextActions } from '../../store/userContextStore';

class AutoLogout extends Component {
  constructor(props) {
    super(props);
    this.logoutTimer = null;
  }

  componentDidMount() {
    this.resetLogoutTimer();
    document.addEventListener('click', this.resetLogoutTimer);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.authentication && prevProps.authentication.isAuthorized === false &&
      this.props.authentication && this.props.authentication.isAuthorized === true) {
      this.resetLogoutTimer();
    }
  }

  componentWillUnmount() {
    clearTimeout(this.logoutTimer);
    document.removeEventListener('click', this.resetLogoutTimer);
  }

  resetLogoutTimer = () => {
    clearTimeout(this.logoutTimer);
    if (this.props.authentication && this.props.authentication.isAuthorized) {
      const ms = this.props.authentication.autologoutTimeout || 14400000; // 4 hours
      this.logoutTimer = setTimeout(this.logoutUser, ms);
    }
  };

  logoutUser = () => {
    this.props.resetSubjects();
    this.props.logoutNotifications();
    this.props.logout();
  };

  render() {
    return <div></div>;
  }
}

export default withLocalize(connect(
  state => state.userContext,
  dispatch => bindActionCreators(Object.assign({}, userContextActions, lastSubjectActions, newsActions), dispatch)
)(AutoLogout));
